import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses, bonusesTitle, bonusesTotal } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-night-800 py-16 md:py-24" data-id="element-14" data-mp="pm2bpwd5bfh1">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-15" data-mp="au1vkqui6mkh">
        <h2 className="mx-auto flex max-w-2xl flex-wrap items-center justify-center gap-3 text-center font-display text-[2rem] font-bold leading-tight tracking-tight text-ink md:text-[2.75rem]" data-id="element-16" data-mp="ftwlos6gf84h">
          <GiftIcon className="h-8 w-8 shrink-0 text-gold-400 md:h-9 md:w-9" strokeWidth={1.5} aria-hidden="true" data-id="element-17" data-mp="5w08zvxvc549" />
          {bonusesTitle}
        </h2>

        <ul className="mt-14 grid gap-5 md:grid-cols-3" data-id="element-18" data-mp="3t0ogy264l9mo">
          {bonuses.map((bonus, index) => <li key={bonus.tag} className="flex h-full flex-col rounded-2xl bg-night-700 p-6 text-left ring-1 ring-white/5" data-id="element-19" data-mp="1mai2fvrzruvq" data-mpi={index}>
              <div className="flex items-baseline justify-between" data-id="element-20" data-mp="1r78t1d1fa8ve">
                <span className="font-display text-3xl font-bold tracking-tight text-night-500" data-id="element-21" data-mp="3id55p9kqj9cd">
                  0{index + 1}
                </span>
                <span className="text-xs font-semibold uppercase tracking-[0.16em] text-gold-400" data-id="element-22" data-mp="3r6qiwoh94ijo">
                  {bonus.tag}
                </span>
              </div>
              <h3 className="mt-4 font-display text-lg font-bold leading-snug tracking-tight text-ink" data-id="element-23" data-mp="3n5y83qsqe5la">
                {bonus.title}
              </h3>
              <p className="mt-3 text-muted" data-id="element-24" data-mp="2uh0va37ah0zx">{bonus.description}</p>
              <p className="mt-auto flex items-center gap-3 pt-6" data-id="element-25" data-mp="2uitx956yix1l">
                <span className="text-sm text-faint line-through" data-id="element-26" data-mp="38htnuie15m0e">Valor: {bonus.value}</span>
                <span className="rounded-lg bg-indigo-500/15 px-3 py-1 font-display text-xs font-bold uppercase tracking-[0.12em] text-indigo-300" data-id="element-27" data-mp="33fm6teecffr7">
                  Gratis
                </span>
              </p>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-narrow rounded-2xl bg-night-900 px-6 py-8 text-center ring-1 ring-gold-400/20" data-id="element-28" data-mp="3cj6gsc65doob">
          <p className="font-display text-xs font-bold uppercase tracking-[0.22em] text-gold-400" data-id="element-29" data-mp="3hgyanbqcrkv5">
            Valor total de los bonos
          </p>
          <p className="mt-3 font-display text-2xl font-bold tracking-tight text-ink md:text-3xl" data-id="element-30" data-mp="3lhry63zvuxni">
            <span className="text-faint line-through" data-id="element-31" data-mp="3qgbjq3ake7fc">{bonusesTotal}</span>
            <span className="ml-3" data-id="element-32" data-mp="2tu9o2cqef487">→ Incluidos gratis hoy</span>
          </p>
        </div>
      </div>
    </section>;
}